import React from 'react';
import PropTypes from 'prop-types';
import neoHubDomain from '../../lib/neoHubDomain';

// Single home for the classic-hub -> neohub redirect stubs that replace pages
// migrated to neohub. `path` is the neohub pathname; the current query string
// rides along so OAuth callback results (?success/?message) and marketplace
// params survive the hop, and so does the fragment (a bookmark anchor, or the
// `#_=_` some IdPs append).
const NeoHubRedirect = ({ path }) => {
  const { origin, pathname, search, hash } = window.location;
  const destination = `${neoHubDomain()}${path}`;
  const target = `${destination}${search}${hash}`;

  // On an origin neoHubDomain() does not rewrite (localhost, an IP, an alias)
  // the target is this very page. Compare only origin + pathname, with any
  // trailing slash trimmed: comparing the raw href would treat `?foo`, `#bar`
  // or a trailing slash as a different page and force a pointless reload
  // before the guard finally caught it.
  const here = `${origin}${pathname.replace(/\/+$/, '')}`;
  if (here !== destination) {
    window.location.href = target;
    return null;
  }

  // Rendering null here would leave a permanently blank page in local dev,
  // where the redirect cannot resolve to a different host.
  return (
    <p>
      This page has moved to <a href={target}>{target}</a>.
    </p>
  );
};

NeoHubRedirect.propTypes = {
  // neohub pathname, leading slash and no trailing slash: '/partnerships/zendesk'
  path: PropTypes.string.isRequired,
};

export default NeoHubRedirect;
